<template>
  <div v-if="!loadPreloader && rowData.length">

    <div class="flex justify-content-start sort-line align-item-center">
      <button class="btn clear-sort" @click="changeSort('')">
        <img src="@/assets/images/icons/close.svg"/>
      </button>
      <button
          :class="{ active: sortType == 'ASC_name' || sortType == 'DESC_name' }"
          class="btn sort-text"
          @click="
        () =>
          sortType === 'ASC_name'
            ? changeSort('DESC_name')
            : changeSort('ASC_name')
      "
      >
        По алфавиту
        <i v-if="sortType === 'ASC_name'" class="fal fa-arrow-down-a-z"></i>
        <i v-if="sortType === 'DESC_name'" class="fal fa-arrow-up-a-z"></i>
      </button>
      <button
          :class="{
        active: sortType == 'DESC_created_at' || sortType == 'ASC_created_at',
      }"
          class="btn sort-text"
          @click="
        () =>
          sortType === 'ASC_created_at'
            ? changeSort('ASC_created_at')
            : changeSort('DESC_created_at')
      "
      >
        По дате регистрации
        <i
            v-if="sortType === 'DESC_created_at'"
            class="fal fa-arrow-down-1-9"
        ></i>
        <i v-if="sortType === 'ASC_created_at'" class="fal fa-arrow-up-1-9"></i>
      </button>
      <button
          @click="() => changeSort('deactivated_date')"
          :class="{ active: sortType == 'deactivated_date' }"
          class="btn sort-text"
      >
        По дате деактивации
      </button>
    </div>
    <base-table
        :rows=rowData
        :columns="staffTableFields" :checkedList=checkedList
    />

    <table-pagination
        :totalPages="15"
        :countOnPage="countOnPage"
        :total="totalUsers"
        :count="users?.length"
        :startPage="currentPage"
        @changePage="changePage"
    />
  </div>
  <div v-if="loadPreloader" class="table-preloader">
    <preloader/>
  </div>
  <div v-if="!loadPreloader && !rowData.length">
    <p class="no_results">
      Нет результатов
    </p>
  </div>
</template>

<script>
import {ref} from "@vue/reactivity";
import {useStore} from "vuex";
import {computed, onBeforeMount} from "@vue/runtime-core";
import {useRoute} from "vue-router";
import Preloader from "@/components/Technical/Preloader.vue";
import TablePagination from "@/components/OtherElements/TablePagination.vue";
import BaseTable from "@/components/Tables/BaseTable.vue";
import {getTestStatus} from "@/feature/group-control/utils/groupPassingUtils";
import {getCourseStatus} from "@/feature/group-control/utils/coursePassingUtils";

export default {
  name: "staff-deactivated-table",
  components: {
    BaseTable,
    Preloader,
    TablePagination,
  },
  setup() {
    const store = useStore(),
        route = useRoute(),
        checkedList = ref([]),
        currentPage = ref(1);

    const loadPreloader = ref(false);
    const sortType = ref("");

    const staffTableFields = [
      {
        field: "name",
        headerName: "Имя",
        link: true,
        dest: 'staff',
        res: "edit",
      },
      {
        field: "status",
        headerName: "Тесты",
        isTest: true
      },
      {
        field: "statusCourse",
        headerName: "Курсы",
        isTest: true
      },
      {
        field: "email",
        headerName: "Email"
      },
      {
        field: "groups",
        headerName: "Группы",
      },
      {
        field: "createdAt",
        headerName: "Дата регистрации",
      },
      {
        field: "deactivated",
        headerName: "Дата деактивации",
      },
      {
        field: "edit",
        headerName: "",
        dest: "staff",
        res: "edit"
      },
    ];
    const countOnPage = ref(15),
        isPreloader = ref(false),
        profile = computed(() => store.state.profile.profile),
        roleOptions = computed(() =>
            !profile.value || profile.value.role !== "superadmin"
                ? ["Не выбрано", "Администратор", "Сотрудник"]
                : [
                  "Не выбрано",
                  "Суперадмин",
                  "Администратор",
                  "Сотрудник",
                  "Частное лицо",
                ]
        );
    const users = computed(() => store.state.users.usersDeactivated);
        const totalUsers = computed(() => store.state.users.totalUsers),
        rowData = computed(() => {
          return users.value.map((staff) => {
            return {
              id: staff.id,
              name: staff.name,
              email: staff.email,
              status: getTestStatus(staff),
              statusCourse: staff.course_passing ? getCourseStatus(staff.course_passing) : 'Не выдан',
              finished_tests: staff.finished_tests,
              deactivated: staff.deactivated,
              createdAt: staff.created_at,
              groups: staff.groups,
              edit: staff.id,
            };
          })
        });

    onBeforeMount(() => {
      loadPreloader.value = true;
      store.dispatch("users/getUsersDeactivated", {
        perPage: 15,
        page: currentPage.value,
      }).then(() => loadPreloader.value = false);
    });

    const usersRequest = () => {
      loadPreloader.value = true;
      store
          .dispatch("users/getUsersDeactivated", {
            perPage: 15,
            page: currentPage.value,
            sort: sortType.value,
          })
          .finally(() => (loadPreloader.value = false));
    };

    const changePage = (page) => {
      if (page !== currentPage.value) {
        currentPage.value = page;
        loadPreloader.value = true;
        usersRequest()
      }
    };

    const changeSort = (type) => {
      sortType.value === type ? (sortType.value = "") : (sortType.value = type);

      usersRequest();
    };

    return {
      route,
      countOnPage,
      isPreloader,
      users,
      roleOptions,
      checkedList,
      totalUsers,
      changePage,
      loadPreloader,
      sortType,
      changeSort,
      staffTableFields,
      rowData,
      currentPage
    };
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  min-width: 350px;
}

.clear-btn {
  margin-left: 15px;
}

.no_results {
  padding: 40px 10px;
}

.sort-btn {
  height: 45px;
  width: 45px;
  margin-left: 10px;
  margin-top: 10px;
  font-size: 17px;

  &::before {
    content: "\f161";
    font-family: "Font Awesome 5 Pro";
    font-size: 17px;
  }
}

.mobile-sort {
  display: none;
}

.sort_list {
  padding-right: 10px;
}

.sort-value {
  padding-left: 40px;
  position: relative;

  &.active::before {
    content: "\f00c";
    position: absolute;
    left: 15px;
    top: 6px;
    font-family: "Font Awesome 5 Pro";
  }
}

.sort-line {
  border-bottom: 1px solid var(--cream-color);
  padding-bottom: 10px;
  margin-top: 15px;

  .clear-sort {
    padding: 0;

    img {
      height: 20px;
      width: 20px;
    }
  }

  .sort-text.active {
    font-weight: 500;
    color: var(--main-color);
  }
}

@media (max-width: 1540px) {
  .staff-filters {
    flex-direction: column;
  }

  .clear-btn {
    align-self: flex-end;
    margin-top: 15px;
    margin-right: 15px;
  }
  .form-group {
    min-width: 100%;
  }
}

@media (max-width: 970px) {
  .sort-line {
    display: none;
  }
  .mobile-sort {
    display: flex;
  }

  .staff-filters {
    top: 0;
    position: sticky;
    padding: 10px 0;
    background-color: #ffffff;
    z-index: 2;
  }
}
</style>
